import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { resendProfileMFACode } from '@perpay-web/fintech/actions/authentication';
import { validateMFACode } from '@perpay-web/fintech/actions/entities/validateMFACodes';
import MFAForm from '@perpay-web/fintech/components/composite/MFAForm/MFAForm';
import { useProfileMFAContext } from '@perpay-web/fintech/hooks/useProfileMFAContext';

const ProfileMFAContainer = ({
    userInfo,
    hideDefaultHeaderOnMobile,
    headerCurrentStep,
    headerSteps,
    headerRightButtonElement,
    headerLeftButtonElement,
    goBackPath,
    userInfoError = {},
    onSuccess,
    loadingOverride,
}) => {
    const dispatch = useDispatch();

    const { otpUuid, errors: mfaErrors, isLoading } = useProfileMFAContext();

    const onSubmitMFACode = useCallback(
        (value) => {
            dispatch(
                validateMFACode({
                    otpUuid,
                    code: value,
                }),
            );
        },
        [dispatch, otpUuid],
    );

    const onSubmitResend = useCallback(
        () => dispatch(resendProfileMFACode({ otpUuid })),
        [dispatch, otpUuid],
    );

    const errors = { ...userInfoError, ...mfaErrors };

    return (
        <MFAForm
            userInfo={userInfo}
            error={errors}
            hideDefaultHeaderOnMobile={hideDefaultHeaderOnMobile}
            isLoading={loadingOverride || isLoading}
            onSubmit={onSubmitMFACode}
            onSubmitResend={onSubmitResend}
            headerCurrentStep={headerCurrentStep}
            headerSteps={headerSteps}
            headerRightButtonElement={headerRightButtonElement}
            headerLeftButtonElement={headerLeftButtonElement}
            goBackPath={goBackPath}
            onSuccess={onSuccess}
        />
    );
};

export default ProfileMFAContainer;
